import { z } from 'zod';

// Ported 1:1 from legacy `travel_planner_back/src/doc-chatbot/dto/*`. The
// documentation chatbot does RAG over the GLOBAL internal-docs vector store
// (`embeddings.document_vector`) — not org-scoped — and returns an answer plus
// the documents it cited. The conversation itself is client-only UI state; the
// last 10 turns ride along on each request as `history`.

export const docChatRoleSchema = z.enum(['user', 'assistant']);

export type DocChatRole = z.infer<typeof docChatRoleSchema>;

export const docChatHistoryItemSchema = z.object({
  role: docChatRoleSchema,
  content: z.string(),
});

export type DocChatHistoryItem = z.infer<typeof docChatHistoryItemSchema>;

// `MaxLength(4000)` on the legacy `ChatMessageDto.message`.
export const docChatInput = z.object({
  message: z.string().min(1).max(4000),
  history: z.array(docChatHistoryItemSchema).optional(),
});

export type DocChatInput = z.infer<typeof docChatInput>;

export const docReferenceSchema = z.object({
  sourceId: z.string(),
  title: z.string(),
  breadcrumbPath: z.array(z.string()).nullable(),
  relevantSection: z.string().nullable(),
  // Integer 0–100 (legacy `Math.round(similarity * 100)`).
  relevanceScore: z.number(),
});

export type DocReference = z.infer<typeof docReferenceSchema>;

export const docChatResponseSchema = z.object({
  message: z.string(),
  references: z.array(docReferenceSchema).optional(),
});

export type DocChatResponse = z.infer<typeof docChatResponseSchema>;

export const docSearchInput = z.object({
  query: z.string().min(1),
  limit: z.number().int().min(1).max(50).default(5),
});

export type DocSearchInput = z.infer<typeof docSearchInput>;

export const docSearchResultSchema = z.object({
  id: z.string(),
  sourceId: z.string(),
  title: z.string(),
  breadcrumbPath: z.array(z.string()).nullable(),
  content: z.string(),
  heading: z.string().nullable(),
  // Cosine similarity 0–1.
  similarity: z.number(),
});

export type DocSearchResult = z.infer<typeof docSearchResultSchema>;

export const docStatsSchema = z.object({
  documentCount: z.number(),
  vectorCount: z.number(),
});

export type DocStats = z.infer<typeof docStatsSchema>;
